import ICONS from "../../../../../assets/Icons";
import formatCurrency from "../../../../../utils/CurrencyFormater";
import DataActionField from "../../../../_utils/TransactionCommonComponents/DataActionField";

const BeneficiaryRecreateTxnStepAmountPaymentMethod = ({
  setIsNeft,
  setIsRtgs,
  txnPayLoad,
  setTxnPayLoad,
  txnData,
  isAmountCopied,
  setIsAmountCopied,
  copyToClipboard,
}) => {
  return (
    <>
      <div className="w-full flex flex-col Qsmd:flex-row gap-gap-md Qsmd:gap-gap-xl mt-[var(--banklogo-width-lg)] Qsmd:mt-margin-base px-padding-md Qlg:px-padding-base py-padding-md">
        <DataActionField
          label="Transfer Amount"
          value={`INR ${formatCurrency(Number(txnData?.amount))}`}
          icon={
            isAmountCopied ||
            Number(txnData?.amount) === Number(txnPayLoad?.amount)
              ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
              : ICONS?.COPY
          }
          onClick={() => {
            const amount = Number(txnData?.amount);
            copyToClipboard("Transfer Amount", "numeric", amount);
            setIsAmountCopied(true);
          }}
          hoverEnabled={isAmountCopied === false}
        />

        <DataActionField
          label="Select Payment Method"
          value={txnData?.payment_method}
          icon={
            txnPayLoad?.settleType?.toUpperCase() === txnData?.payment_method
              ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
              : ICONS?.AUTOFILL_WHITE
          }
          onClick={() => {
            const method = txnData?.payment_method;
            if (txnPayLoad?.settleType?.toUpperCase() === method) return;
            setIsNeft(method === "NEFT");
            setIsRtgs(method === "RTGS");
            setTxnPayLoad((prev) => ({
              ...prev,
              settleType: method?.toLowerCase(),
            }));
          }}
          hoverEnabled={
            txnPayLoad?.settleType?.toUpperCase() !== txnData?.payment_method
          }
        />
      </div>
    </>
  );
};

export default BeneficiaryRecreateTxnStepAmountPaymentMethod;
